import { Audience, CompareInsight } from "@/types";

export const ADD_TO_COMPARE = "ADD_TO_COMPARE";
export const ADD_TO_COMPARE_WITH_INSIGHT = "ADD_TO_COMPARE_WITH_INSIGHT";
export const REMOVE_FROM_COMPARE = "REMOVE_FROM_COMPARE";
export const CLEAR_COMPARE = "CLEAR_COMPARE"
export const ADD_COMPARE_INSIGHT = "ADD_COMPARE_INSIGHT"
export const INITIALISE_COMPARE_INSIGHT = "INITIALISE_COMPARE_INSIGHT"
export const SET_COMPARE_LOADING = "SET_COMPARE_LOADING";
export const SET_COMPARE_ERROR = "SET_COMPARE_ERROR";

// export const REPLACE_AUDIENCE_IN_COMPARISON = "REPLACE_AUDIENCE_IN_COMPARISON";
// export const CLEAR_INSIGHTS_FROM_COMPARISON = "CLEAR_INSIGHTS_FROM_COMPARISON";
// export const GET_INSIGHTS_FOR_COMPARISON = "GET_INSIGHTS_FOR_COMPARISON";

export type CompareAction =
  | { type: typeof ADD_TO_COMPARE; payload: { audience: Audience, index?: number } }
  | { type: typeof ADD_TO_COMPARE_WITH_INSIGHT; payload: { audience: Audience, insight: CompareInsight } }
  | { type: typeof REMOVE_FROM_COMPARE; payload: Audience }
  | { type: typeof CLEAR_COMPARE }
  | { type: typeof ADD_COMPARE_INSIGHT; payload: {insight: CompareInsight, index?: number} }
  | { type: typeof INITIALISE_COMPARE_INSIGHT; payload: {audience_id: string, index: number}}
  | { type: typeof SET_COMPARE_LOADING; payload: boolean }
  | { type: typeof SET_COMPARE_ERROR; payload: string | null }


export interface CompareState {
  comparisonAudiences: Audience[];
  comparisonInsights: CompareInsight[];
  loading: boolean;
  error: string | null;
}

export const initialState: CompareState = {
  comparisonAudiences: [],
  comparisonInsights: [],
  loading: false,
  error: null,
};
